import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductDetailsUiStateService } from '../../product-details-ui-state.service';
import { FormGroup } from '@angular/forms';
import { ClientTransactionViewForm } from 'src/app/models/forms/transactions-form';
import { DynamicOptionResponse } from 'src/app/models/products/transactions';

@Component({
  selector: 'app-dynamic-option-fields',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './dynamic-option-fields.component.html',
  styleUrls: ['../../online-product-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicOptionFieldsComponent {
  @Input() clientTransactionViewForm: FormGroup<ClientTransactionViewForm>;

  constructor(public pUiService: ProductDetailsUiStateService){
  }

  onDynamicOptionChange(dynamicOptionIndex: number, event: Event){
    const dynamicOptionItemId =+(event.target as HTMLSelectElement).value;
    const dynamicOption = this.pUiService.productView.ProductOptionItems[this.pUiService.currentOptionIndex]
    .DynamicProductOptions[dynamicOptionIndex]
    const dynamicOptionItem = dynamicOption.DynamicProductOptionItems.find(x=>x.Id === dynamicOptionItemId);
    const optionValue = new DynamicOptionResponse();
    optionValue.Active = true;
    optionValue.Created = new Date().toISOString();
    optionValue.DynamicOptionItemId = dynamicOptionItemId;
    optionValue.Id = dynamicOptionItem.Id;
    optionValue.Label = dynamicOption.OptionTitle;
    optionValue.OptionId = dynamicOption.Id;
    optionValue.Price = dynamicOptionItem.Price;
    optionValue.TransactionId = 0;
    optionValue.Updated = new Date().toISOString();
    optionValue.Value = dynamicOption.OptionTitle;

    this.clientTransactionViewForm.get(['DynamicOptionResponses', dynamicOptionIndex])
    .setValue(
      optionValue
    )
  }

  getSelectedDynamicFieldPrice(dynamicOptionIndex: number): number {
    return this.pUiService.getSelectedDynamicFieldPrice(dynamicOptionIndex);
  }

 }
